import { createRouter, createWebHistory } from 'vue-router'
import HomePage from './views/HomePage.vue'
import AboutPage from './views/AboutUsPage.vue'
import chat from './components/QuickChat.vue'
import RoofingPage from './views/PhotoGallery/RoofingPage.vue'
import RepairsPage from './views/PhotoGallery/RepairsPage.vue'
import SidingPage from './views/PhotoGallery/SidingPage.vue'
import GutterPage from './views/PhotoGallery/GutterPage.vue'
import FasciaSoffet from './views/PhotoGallery/FasciaSoffet.vue'
import NotFoundPage from './views/NotFoundPage.vue'

const routes = [
  { path: '/', component: HomePage },
  { path: '/about', component: AboutPage },
  { path: '/roofing-projects', component: RoofingPage },
  { path: '/repair-projects', component: RepairsPage },
  { path: '/siding-services', component: SidingPage },
  { path: '/fascia-soffit', component: FasciaSoffet },
  { path: '/gutter-services', component: GutterPage },
  { path: '/chat', component: chat },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFoundPage }

]

const router = createRouter({
    history: createWebHistory(),
    routes
  })

  


export default router